webpackJsonp([97535635309342],{

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(68);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactFlexboxGrid = __webpack_require__(21);
	
	var _content = __webpack_require__(22);
	
	var _markdownComponents = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var page = data.page,
	      currentBook = data.currentBook,
	      lastBook = data.lastBook;
	
	
	  return _react2.default.createElement(
	    _content.Paper,
	    null,
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { center: "xs" },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12 },
	        _react2.default.createElement(_gatsbyImage2.default, { resolutions: currentBook.resolutions,
	          alt: "Our current book - Scala For Impatient",
	          title: "Our current book - Scala For Impatient" })
	      )
	    ),
	    (0, _markdownComponents.renderAst)(page.htmlAst),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { center: "xs" },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12 },
	        _react2.default.createElement(_gatsbyImage2.default, { resolutions: lastBook.resolutions,
	          alt: "Our last book - The Little Elixir and OTP Guidebook",
	          title: "Our last book - The Little Elixir and OTP Guidebook" })
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-book-club-js-1245772ce8598126f75d.js